// extracted by mini-css-extract-plugin
module.exports = {"icon_wrapper":"Icon_icon_wrapper__fie9s","big":"Icon_big__Xvpor"};